export default "__VITE_ASSET__Cz1u4YkW__"